import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../BasketPxDetailsStyled';

export const BasketPxDetailsAP = styled(BasketPxDetailsStyled)``;
